export const JOTFORM_REFERRAL_PRODUCTION = 'https://form.jotform.com/230965186262158';
export const JOTFORM_REFERRAL_STAGING = 'https://form.jotform.com/231634365310145';

export default {};
